module.exports = __webpack_public_path__ + "img/f3.ff67ad70.png";